import { Button } from '@repo/videa-components/src/index';
import { NoteGenerationError } from '@repo/videa-notes';

import type { VideaNotesProcessingError } from '../../types';

interface NoteErrorViewProps {
  error: VideaNotesProcessingError;
  onDismiss: () => void;
}

export const NoteErrorView = ({ error, onDismiss }: NoteErrorViewProps) => {
  return (
    <div className="vai-flex vai-flex-col vai-px-1">
      <NoteGenerationError {...error} />
      <div className="vai-mt-4 vai-pb-3 vai-self-start">
        <Button onClick={onDismiss} variant="destructive">
          <span>Dismiss</span>
        </Button>
      </div>
    </div>
  );
};
